var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeWawes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    viewBox: "0 0 200 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.96082C11.1084 1.96082 11.1084 19.6079 22.217 19.6079C33.3254 19.6079 33.3254 1.96082 44.4339 1.96082C55.5425 1.96082 55.5424 19.6079 66.6508 19.6079C77.7593 19.6079 77.7593 1.96082 88.868 1.96082C99.9765 1.96082 99.9765 19.6079 111.084 19.6079C122.193 19.6079 122.193 1.96082 133.302 1.96082C144.41 1.96082 144.41 19.6079 155.519 19.6079C166.627 19.6079 166.627 1.96082 177.76 1.96082C188.891 1.96082 188.868 19.6079 200 19.6079",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.549C11.1084 72.549 11.1084 90.1961 22.217 90.1961C33.3254 90.1961 33.3254 72.549 44.4339 72.549C55.5425 72.549 55.5424 90.1961 66.6508 90.1961C77.7593 90.1961 77.7593 72.549 88.868 72.549C99.9765 72.549 99.9765 90.1961 111.084 90.1961C122.193 90.1961 122.193 72.549 133.302 72.549C144.41 72.549 144.41 90.1961 155.519 90.1961C166.627 90.1961 166.627 72.549 177.76 72.549C188.891 72.549 188.868 90.1961 200 90.1961",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4902C11.1151 25.4902 11.1151 43.1373 22.2301 43.1373C33.3452 43.1373 33.3452 25.4902 44.4603 25.4902C55.5754 25.4902 55.5753 43.1373 66.6904 43.1373C77.8055 43.1373 77.8055 25.4902 88.9208 25.4902C100.035 25.4902 100.035 43.1373 111.151 43.1373C122.266 43.1373 122.266 25.4902 133.381 25.4902C144.496 25.4902 144.496 43.1373 155.611 43.1373C166.726 43.1373 166.702 25.4902 177.746 25.4902C188.79 25.4902 188.862 43.1373 200 43.1373",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 119.608C11.1151 119.608 11.1151 137.255 22.2301 137.255C33.3452 137.255 33.3452 119.608 44.4603 119.608C55.5754 119.608 55.5753 137.255 66.6904 137.255C77.8055 137.255 77.8055 119.608 88.9208 119.608C100.035 119.608 100.035 137.255 111.151 137.255C122.266 137.255 122.266 119.608 133.381 119.608C144.496 119.608 144.496 137.255 155.611 137.255C166.726 137.255 166.702 119.608 177.746 119.608C188.79 119.608 188.862 137.255 200 137.255",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.0197C11.1084 49.0197 11.1084 66.6667 22.217 66.6667C33.3254 66.6667 33.3254 49.0197 44.4339 49.0197C55.5425 49.0197 55.5424 66.6667 66.6508 66.6667C77.7593 66.6667 77.7593 49.0197 88.868 49.0197C99.9765 49.0197 99.9765 66.6667 111.084 66.6667C122.193 66.6667 122.193 49.0197 133.302 49.0197C144.41 49.0197 144.41 66.6667 155.519 66.6667C166.627 66.6667 166.627 49.0197 177.76 49.0197C188.891 49.0197 188.868 66.6667 200 66.6667",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 96.0784C11.1084 96.0784 11.1084 113.725 22.217 113.725C33.3254 113.725 33.3254 96.0784 44.4339 96.0784C55.5425 96.0784 55.5424 113.725 66.6508 113.725C77.7593 113.725 77.7593 96.0784 88.868 96.0784C99.9765 96.0784 99.9765 113.725 111.084 113.725C122.193 113.725 122.193 96.0784 133.302 96.0784C144.41 96.0784 144.41 113.725 155.519 113.725C166.627 113.725 166.627 96.0784 177.76 96.0784C188.891 96.0784 188.868 113.725 200 113.725",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 139.216,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeWawes);
export default __webpack_public_path__ + "static/media/shape-wawes.6bc2887f8b4f15f639b32e266d630628.svg";
export { ForwardRef as ReactComponent };